import ApiConfig from '@/api-config-request';
import requestPost from '@/api/request';
//导航菜单
const post5c98e475427d2 = (option) => {
    let url = ApiConfig.post5c98e475427d2;
    return requestPost.RequestPost(url, option)
};
// 新 - 首页最新列表
const post62bbca2331de7 = (option) => {
    let url = ApiConfig.post62bbca2331de7;
    return requestPost.RequestPost(url, option)
};
// 获取首页公告（轮播图下方，固定条数）
const post62b329d25116a = (option) => {
    let url = ApiConfig.post62b329d25116a;
    return requestPost.RequestPost(url, option)
};
// 获取指定广告位的广告列表
const post5c94aa1a043e7 = (option) => {
    let url = ApiConfig.post5c94aa1a043e7;
    return requestPost.RequestPost(url, option)
};
// 首页-哈哈镜头接口
const post62bbea32751d9 = (option) => {
    let url = ApiConfig.post62bbea32751d9;
    return requestPost.RequestPost(url, option)
};
// 论坛接口列表
const post62cbe57f5ec04 = (option) => {
    let url = ApiConfig.post62cbe57f5ec04;
    return requestPost.RequestPost(url, option)
};
// 论坛详情
const post62bd647d75500 = (option) => {
    let url = ApiConfig.post62bd647d75500;
    return requestPost.RequestPost(url, option)
};
// 	哈法看点信息列表
const post62bbf0a622efa = (option) => {
    let url = ApiConfig.post62bbf0a622efa;
    return requestPost.RequestPost(url, option)
};
// 	哈法看点详情
const post62bbfd5d5fa48 = (option) => {
    let url = ApiConfig.post62bbfd5d5fa48;
    return requestPost.RequestPost(url, option)
};
// 	哈法详情-为您推荐
const post62bbff89cf013 = (option) => {
    let url = ApiConfig.post62bbff89cf013;
    return requestPost.RequestPost(url, option)
};
// 	十类文章评论列表接口
const post62bc007adce19 = (option) => {
    let url = ApiConfig.post62bc007adce19;
    return requestPost.RequestPost(url, option)
};
// 	十类文章评论提交接口
const post62bc05a7e6bf1 = (option) => {
    let url = ApiConfig.post62bc05a7e6bf1;
    return requestPost.RequestPost(url, option)
};
// 	二手交易列表
const post62bc144344dee = (option) => {
    let url = ApiConfig.post62bc144344dee;
    return requestPost.RequestPost(url, option)
};
// 	二手交易详情
const post62bc1558294ee = (option) => {
    let url = ApiConfig.post62bc1558294ee;
    return requestPost.RequestPost(url, option)
};
// 	二手交易详情
const post62bc202f0e6d5 = (option) => {
    let url = ApiConfig.post62bc202f0e6d5;
    return requestPost.RequestPost(url, option)
};
// 	租房列表接口
const post62bc1a6ac97db = (option) => {
    let url = ApiConfig.post62bc1a6ac97db;
    return requestPost.RequestPost(url, option)
};
// 	租房详情
const post62bc1daa685f9 = (option) => {
    let url = ApiConfig.post62bc1daa685f9;
    return requestPost.RequestPost(url, option)
};
// 	租房-为您推荐
const post62bc20cc76110 = (option) => {
    let url = ApiConfig.post62bc20cc76110;
    return requestPost.RequestPost(url, option)
};
// 	二手车列表
const post62bc2250cd5b5 = (option) => {
    let url = ApiConfig.post62bc2250cd5b5;
    return requestPost.RequestPost(url, option)
};
// 二手车详情
const post62bc25bc644b0 = (option) => {
    let url = ApiConfig.post62bc25bc644b0;
    return requestPost.RequestPost(url, option)
};
// 二手车详情
const post62bc257612ae7 = (option) => {
    let url = ApiConfig.post62bc257612ae7;
    return requestPost.RequestPost(url, option)
};
// 招聘列表
const post62bc26bdb7092 = (option) => {
    let url = ApiConfig.post62bc26bdb7092;
    return requestPost.RequestPost(url, option)
};
// 招聘详情
const post62bc288dc6e04 = (option) => {
    let url = ApiConfig.post62bc288dc6e04;
    return requestPost.RequestPost(url, option)
};
// 招聘-为您推荐
const post62bc291a0471c = (option) => {
    let url = ApiConfig.post62bc291a0471c;
    return requestPost.RequestPost(url, option)
};
// 十类文章分类接口
const post62bbebb06f8ac = (option) => {
    let url = ApiConfig.post62bbebb06f8ac;
    return requestPost.RequestPost(url, option)
};
// 今日折扣列表接口
const post62bc10bef37b5 = (option) => {
    let url = ApiConfig.post62bc10bef37b5;
    return requestPost.RequestPost(url, option)
};
// 今日折扣详情
const post62bc1215cd5e7 = (option) => {
    let url = ApiConfig.post62bc1215cd5e7;
    return requestPost.RequestPost(url, option)
};
// 入驻商家列表接口
const post62bbeddcaf763 = (option) => {
    let url = ApiConfig.post62bbeddcaf763;
    return requestPost.RequestPost(url, option)
};
// 入驻商家详情
const post62bc0e0204f3a = (option) => {
    let url = ApiConfig.post62bc0e0204f3a;
    return requestPost.RequestPost(url, option)
};
// 宠物列表
const post62bc2973585a9 = (option) => {
    let url = ApiConfig.post62bc2973585a9;
    return requestPost.RequestPost(url, option)
};
// 宠物详情
const post62bc2a3ad9511 = (option) => {
    let url = ApiConfig.post62bc2a3ad9511;
    return requestPost.RequestPost(url, option)
};
// 宠物推荐
const post62bc2bc4c89a8 = (option) => {
    let url = ApiConfig.post62bc2bc4c89a8;
    return requestPost.RequestPost(url, option)
};
// 本地生活列表
const post62bc12ae42893 = (option) => {
    let url = ApiConfig.post62bc12ae42893;
    return requestPost.RequestPost(url, option)
};
// 本地生活详情
const post62bc13e029178 = (option) => {
    let url = ApiConfig.post62bc13e029178;
    return requestPost.RequestPost(url, option)
};
// 所有消息数量
const post62bd50a65532f = (option) => {
    let url = ApiConfig.post62bd50a65532f;
    return requestPost.RequestPost(url, option)
};
// 区域列表
const post62bd4f3c2df91 = (option) => {
    let url = ApiConfig.post62bd4f3c2df91;
    return requestPost.RequestPost(url, option)
};
// 粉丝/关注列表
const post62bd05e0f4019 = (option) => {
        let url = ApiConfig.post62bd05e0f4019;
        return requestPost.RequestPost(url, option)
    }
    // 个人中心用户信息
const post62bd01fd4eb3d = (option) => {
        let url = ApiConfig.post62bd01fd4eb3d;
        return requestPost.RequestPost(url, option)
    }
    // 提交意见反馈
const post5cc3f28296cf0 = (option) => {
        let url = ApiConfig.post5cc3f28296cf0;
        return requestPost.RequestPost(url, option)
    }
    // 获取投诉建议反馈类型
const post5d63ba953ee01 = (option) => {
        let url = ApiConfig.post5d63ba953ee01;
        return requestPost.RequestPost(url, option)
    }
    // 图片上传
const post5d5fa8984f0c2 = (option) => {
        let url = ApiConfig.post5d5fa8984f0c2;
        return requestPost.RequestPost(url, option)
    }
    // 拉黑提交接口
const post62bd08245bbad = (option) => {
        let url = ApiConfig.post62bd08245bbad;
        return requestPost.RequestPost(url, option)
    }
    // 关注/取消关注
const post62bd55cd493f2 = (option) => {
        let url = ApiConfig.post62bd55cd493f2;
        return requestPost.RequestPost(url, option)
    }
    // 十类文章的收藏/取消收藏接口
const post62bc0882b98c1 = (option) => {
        let url = ApiConfig.post62bc0882b98c1;
        return requestPost.RequestPost(url, option)
    }
    // 搜索结果页
const post62bcf9d10166f = (option) => {
        let url = ApiConfig.post62bcf9d10166f;
        return requestPost.RequestPost(url, option)
    }
    // 十类文章的点赞接口
const post62bc08003d16d = (option) => {
        let url = ApiConfig.post62bc08003d16d;
        return requestPost.RequestPost(url, option)
    }
    // 获取pc端 ios及小程序下载二维码接口
const post632a64e2cbd05 = (option) => {
        let url = ApiConfig.post632a64e2cbd05;
        return requestPost.RequestPost(url, option)
    }
    //本地生活-为您推荐接口
const post62bc1f41d3df3 = (option) => {
        let url = ApiConfig.post62bc1f41d3df3;
        return requestPost.RequestPost(url, option)
    }
    //本地生活-为您推荐接口
const post62bd0b062c83d = (option) => {
        let url = ApiConfig.post62bd0b062c83d;
        return requestPost.RequestPost(url, option)
    }
    //主页列表及发布中列表
const post62bcfb34c52e7 = (option) => {
    let url = ApiConfig.post62bcfb34c52e7;
    return requestPost.RequestPost(url, option)
}
    //举报
const post62bd0f3c09fb5 = (option) => {
    let url = ApiConfig.post62bd0f3c09fb5;
    return requestPost.RequestPost(url, option)
}
    //pc首页右侧商家列表接口  
const post636a01fbd286d = (option) => {
    let url = ApiConfig.post636a01fbd286d;
    return requestPost.RequestPost(url, option)
}
    //pc公告详情  
const post5d64a46459991 = (option) => {
    let url = ApiConfig.post5d64a46459991;
    return requestPost.RequestPost(url, option)
}


const post63687667584ca = (option) => {
    let url = ApiConfig.post63687667584ca;

    console.log(post63687667584ca,'okokokok')
    return requestPost.RequestPost(url, option)
}

const post63687a04ce172 = (option) => {
    let url = ApiConfig.post63687a04ce172;

    console.log(post63687667584ca,'okokokok')
    return requestPost.RequestPost(url, option)
}

const post63687d1a5bfb4 = (option) => {
    let url = ApiConfig.post63687d1a5bfb4;

    // console.log(post63687667584ca,'okokokok')
    return requestPost.RequestPost(url, option)
}

const post63687c01c5bfe = (option) => {
    let url = ApiConfig.post63687c01c5bfe;

    // console.log(post63687c01c5bfe,'okokokok')
    return requestPost.RequestPost(url, option)
}

let apiConfig = {
	post5d64a46459991,//公告详情
	post636a01fbd286d, //pc首页右侧商家列表接口  
    post5c98e475427d2, //导航菜单
    post62bbca2331de7, // 新 - 首页最新列表
    post62b329d25116a, // 获取首页公告（轮播图下方，固定条数）
    post5c94aa1a043e7, // 获取指定广告位的广告列表
    post62bbea32751d9, //首页-哈哈镜头接口
    post62cbe57f5ec04, //论坛接口列表
    post62bd647d75500, //论坛详情
    post62bbf0a622efa, //哈法看点信息列表
    post62bbfd5d5fa48, //哈法看点详情
    post62bbff89cf013, //哈法详情-为您推荐
    post62bc007adce19, //十类文章评论列表接口
    post62bc05a7e6bf1, //十类文章评论提交接口
    post62bc144344dee, //二手交易列表
    post62bc1558294ee, //二手交易详情
    post62bc202f0e6d5, //二手交易-为您推荐接口
    post62bc1a6ac97db, //租房列表接口
    post62bc1daa685f9, //租房详情
    post62bc20cc76110, //租房-为您推荐
    post62bc2250cd5b5, //二手车列表
    post62bc25bc644b0, //二手车详情
    post62bc257612ae7, //二手车-为您推荐	
    post62bc26bdb7092, //招聘列表
    post62bc288dc6e04, //招聘详情
    post62bc291a0471c, //招聘-为您推荐
    post62bbebb06f8ac, //十类文章分类接口
    post62bc10bef37b5, //今日折扣列表接口
    post62bc1215cd5e7, //今日折扣详情
    post62bbeddcaf763, //入驻商家列表接口
    post62bc0e0204f3a, //入驻商家详情
    post62bc2973585a9, //宠物列表
    post62bc2a3ad9511, //宠物详情
    post62bc2bc4c89a8, //宠物推荐
    post62bc12ae42893, //本地生活列表
    post62bc13e029178, //本地生活详情
    post62bd50a65532f, //所有消息数量
    post62bd4f3c2df91, //区域列表
    post62bd05e0f4019, // 粉丝/关注列表
    post62bd01fd4eb3d, //个人中心用户信息
    post5cc3f28296cf0, //提交意见反馈
    post5d63ba953ee01, //获取投诉建议反馈类型
    post5d5fa8984f0c2, //图片上传
    post62bd08245bbad, //拉黑提交接口
    post62bd55cd493f2, //关注/取消关注
    post62bc0882b98c1, //十类文章的收藏/取消收藏接口
    post62bcf9d10166f, //搜索结果页
    post62bc08003d16d, //十类文章的点赞接口
    post632a64e2cbd05, //获取pc端 ios及小程序下载二维码接口
    post62bc1f41d3df3, //本地生活-为您推荐接口
    post62bd0b062c83d, //举报原因列表
    post62bcfb34c52e7, //主页列表及发布中列表
	post62bd0f3c09fb5, //举报
    post63687667584ca, //保存环信聊天记录及生成聊天列表
    post63687a04ce172, //获取会话列表
    post63687c01c5bfe, //获取聊天记录
    post63687d1a5bfb4, //批量删除会话列表
}
export default apiConfig;


// WEBPACK FOOTER //
// ./src/api/request/index.js